import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import AnimationClip from '../AnimationClip';
import Point from '../../../Utility/Point';
import { Random } from '../../../Utility/Random';
import { delay } from '../../../Utility/Task/TaskQueue';

type LevelScreenShakeMeta = {
    frequency: number;
    damping: number;
    amplitude: number;
    position: Point;
};

export class LevelScreenShake extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: LevelScreenShakeMeta
    ): IterableIterator<number> {
        const transform = gameObject.getComponent(TransformComponent);
        const position = meta.position || transform.position.clone() as Point;

        const frequency = meta.frequency || 50;
        const damping = meta.damping || 0.8;
        let amplitude = meta.amplitude || 5;

        transform.position.set(position.x, position.y);

        while (amplitude > 0.05) {
            transform.position.set(
                position.x + amplitude * Random.value(-1, 1),
                position.x + amplitude * Random.value(-1, 1)
            );

            amplitude *= damping;

            yield* delay(frequency);
        }

        transform.position.set(position.x, position.y);
    }
}
